import { registerRoute } from "../server";

export default function registerRoutes() {
  registerRoute({
    id: "getFeatureFlagLaunchDarkly",
    route: "simpleFeatureFlag/launchDarklyEvaluate",
    method: "post",
    generateResponse: function (config, schema, request) {
      return [];
    },
  });
}
